import { useState, useEffect, Fragment } from "react";
import Loading from "src/components/Loading";
import { getItemsRequest } from "src/modules/spItems/api";
import { equipmentsListName } from "src/api/config";
import { SubResetFilter } from "src/pages/DashboardPage/mytasks/meetingsPage/components/MeetingCard";
import { TGDisclosure } from "../../TGDisclosure";
import { twMerge } from "tailwind-merge";
import { SearchUI } from "../../Search";
import { FlexCol } from "src/utils/flexLayouts";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";
import { TooltipItem } from "src/utils/Tooltip";

type Props = {
    dataField: any;
    onChange: (data: any) => void;
    value: any;
    errors?: any;
}

export default function CheckboxSearch(props: Props) {
    const { dataField, onChange, value, errors } = props;
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchResults, setSearchResults] = useState<any>([]);

    useEffect(() => {
        if (query.length >= 5) {
            setSearchResults([]);
            setLoading(true);
            let re = /[()]/gi;
            let clearQuery = query.replace(re, '');
            getItemsRequest({ listName: equipmentsListName, filters: { [dataField.searchApiField]: `${clearQuery}*` }, rowLimit: 300 }).then(results => {
                const equipments = [...results.items];
                if (equipments.length > 0) {
                    setSearchResults(equipments.map((item: any) => {
                        return {
                            id: item.ID,
                            name: item[dataField.searchApiField],
                            key: dataField.key
                        }
                    }));
                } else {
                    setLoading(false);
                }
            });
        }
    }, [query]);

    useEffect(() => {
        if (searchResults.length > 0) {
            setLoading(false);
        }
    }, [searchResults])

    return (
        <TGDisclosure wrapperClassName={dataField.width} noticeIcon={dataField.noticeIcon && <TooltipItem wrapperClassName="flex" position="filter" className="left-[-240px]" tooltipsComponent={dataField.notice} tooltipsText="">
            <>&nbsp;&nbsp;<InfoIcon /></>
        </TooltipItem>} title={dataField.title} count={value && value.length || 0}>
            <SearchUI placeholder={dataField.placeholder} defaultValue={query} onClick={setQuery} />
            <div className="relative mt-2">
                {!loading && searchResults.length > 0 && searchResults.map((option: any, idx: number) => (
                    <label
                        className={twMerge("flex cursor-pointer select-none text-black mb-2")}
                        key={option.id}
                    >
                        <div className="relative">
                            <input value={option.id} type="checkbox" checked={value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 || false} onChange={(e) => {
                                let newValue = value && [...value] || [];
                                if (newValue.length > 0 && newValue.find((f: any) => String(f.id) === e.target.value)) {
                                    const filtered = value.filter((n: any) => String(n.id) !== e.target.value);
                                    newValue = filtered;
                                } else {
                                    newValue.push(option);
                                }
                                onChange(newValue);
                            }} className="sr-only" />
                            <div
                                className={twMerge(
                                    "flex items-center justify-center w-5 h-5 mr-4 border rounded box border-stroke",
                                    value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 && "border-[#012169]" || "",
                                )}
                            >
                                <span className={twMerge(value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 && "opacity-100" || "opacity-0")}>
                                    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                                            fill="#012169"
                                            stroke="#012169"
                                            strokeWidth="0.4"
                                        ></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        {option.name}
                    </label>
                )) || loading &&
                    <FlexCol className="items-center justify-center w-full">
                        <span className="text-base text-darkblue">Получаем данные...</span>
                        <Loading />
                    </FlexCol>
                    || query.length < 5 &&
                    <FlexCol className="items-center justify-center w-full">
                        <span>Минимальное количество символов для поиска {query.length}/5</span>
                    </FlexCol>
                    || <FlexCol className="items-center justify-center w-full">
                        <span>Данные не найдены</span>
                    </FlexCol>
                }
            </div>
            {dataField.notice && <div className="text-sm text-[#6B7280]">{dataField.notice}</div>}
            <SubResetFilter resetFilter={() => {
                onChange(null);
                setQuery("");
            }} />
        </TGDisclosure>
    )
}
